module.exports = __webpack_public_path__ + "img/image59.0f5655bc.png";